<template>
  <div>
    <van-search
      placeholder="请输入搜索关键词"
      @click="gosearch"
    />

    <!-- <div class="class"></div> -->
    <class></class>
     <van-tabbar  @change="goc" active-color="#ee0a24" v-model="active">
  <van-tabbar-item icon="home-o">主页</van-tabbar-item>
  <van-tabbar-item icon="apps-o">分类</van-tabbar-item>
  <van-tabbar-item icon="logistics">厂家直发</van-tabbar-item>
  <!-- <van-icon name="" /><van-icon name="logistics" /> -->
  <!-- <van-tabbar-item icon="setting-o">标签</van-tabbar-item> -->
</van-tabbar>
  </div>
</template>
<script>
import Vue from 'vue'

import { Search, Tab, Tabs, Icon, Tabbar, TabbarItem } from 'vant'
import Class from '../../class/class1'
// import Search from '../components/page/search'
Vue.use(Search)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
export default {
  data(){
    return{
      active:1
    }
  },
  methods: {
    gosearch () {
      this.$router.push('search')
    },
    goc(v){
      console.log(v)
      if(v==0){
      this.$router.push('shop')

      }
    }
  },
  components: {
    Class,
  }
}
</script>
<style lang="less" scoped>
.class {
  width: 100%;
  height: 10%;
}
</style>
